import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'

// 发送广播
const saveBroadcast = obj => new Promise((resolve, reject) => {
    const {
        sendForm,
        token
    } = obj;
    request({
        url: apis.broadcast_save + '?token=' + token,
        data: sendForm
    }).then(res => {
        resolve(res);
    })
});

// 停止广播/继续广播
const changeBroadcast = obj => new Promise((resolve, reject) => {
    const {
        switchSysMsgForm,
        token
    } = obj;
    request({
        url: apis.broadcast_change + '?token=' + token,
        data: switchSysMsgForm
    }).then(res => {
        resolve(res);
    })
});

// 查询公告发送记录
const findAllBroadcast = token => new Promise((resolve, reject) => {
    request({
        url: apis.broadcast_all + '?token=' + token,
    }).then(res => {
        resolve(res);
    })
});

export default {
    saveBroadcast,
    findAllBroadcast,
    changeBroadcast
}



// WEBPACK FOOTER //
// ./src/service/broadcast_api.js